export default "__VITE_PUBLIC_ASSET__40f7eea1__"